import { createContext, useContext } from "react";
import type { CtaPosition } from "@/utils/dataLayer";

/**
 * CTA position on the page (§ 3.2 ctaPosition). Set per region by a provider
 * (form, footer, header, …) so CTAs report where they sit without each call
 * site passing it. Defaults to "section" — a generic in-content CTA — for
 * anything rendered outside a labeled region. An explicit `ctaPosition` prop on
 * a CTA still overrides the contextual value.
 */
export const CtaPositionContext = createContext<CtaPosition>("section");

export const useCtaPosition = () => useContext(CtaPositionContext);
